import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    loginContainer: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    loginForm: {
        width: 552,
    },
    loginTitle: {
        width: 552,
        textAlign: "left",
        color: theme.palette.secondary.dark,
        marginBottom: `${theme.spacing(10)} !important`,
    },
    fieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
        justifyContent: "center",
        alignItems: "center",
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans !important",
            fontSize: "16px !important",
            fontWeight: "400 !important",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans !important",
                fontSize: "16px !important",
                fontWeight: "400 !important",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans !important",
            fontSize: "16px !important",
            fontWeight: "400 !important",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    errorMessage: {
        color: theme.palette.error.main,
        marginTop: theme.spacing(8),
    },
    submitButton: {
        "&.MuiButtonBase-root": {
            background: theme.palette.info.light,
            color: "white",
            height: "42px !important",
            width: "100%",
            fontFamily: "Open Sans",
            marginTop: theme.spacing(8),
            "&:hover": {
                background: theme.palette.info.light,
            },
        },
    },
    forgotPasswordLink: {
        color: theme.palette.secondary.dark,
        "& .MuiTypography-root": {
            marginTop: theme.spacing(6),
        },
    },
}));
